var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"cz2__ai-modal__disclaimer",domProps:{"innerHTML":_vm._s(_vm.messageCopy)}})
}
var staticRenderFns = []

export { render, staticRenderFns }